import {
  EVENT_CARDS_CHANGED,
  EVENT_NEW_OPERATION,
  EVENT_PHYSICAL_CARD_APPEARED,
} from '@/shared/lib/events/eventsConstants';
import { useHasActiveCardGuard } from '@/shared/guards/useHasActiveCardGuard';
import { useUserStore } from '@/shared/store/useUserStore';

export function eventsHandle(action: any = {}) {
  if (action.type === 'events/addEvent') {
    const userStore = useUserStore();

    if (
      action.payload.type === EVENT_PHYSICAL_CARD_APPEARED ||
      action.payload.type === EVENT_CARDS_CHANGED
    ) {
      userStore.fetchPhysicalUserCard();
      useHasActiveCardGuard();
    }

    if (action.payload.type === EVENT_NEW_OPERATION) {
      userStore.fetchAllOperations();
    }
  }
}
